<template>
  <div>
    <section-title content="Seleccione Rol(es)" has-line />
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 border-right">
        <validation-observer ref="form">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="appSelected"
              label="Aplicación:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              custom-error-msg="La aplicación es requerida."
              :error="errors[0]"
              :options="appOptions"
              :disabled="isAppDisabled"
              @input="getRoles"
            />
          </validation-provider>

          <div class="my-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="role"
                label="Rol:"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="El rol es requerido."
                :error="errors[0]"
                :options="roleOptions"
                :disabled="isRoleDisabled"
              />
            </validation-provider>
          </div>

          <div class="d-flex justify-content-end">
            <action-button
              i="fas fa-file-plus"
              text="Añadir"
              variant="success mt-2"
              @click="add"
            />
          </div>
        </validation-observer>
      </div>
      <div class="col-12 col-md col-lg">
        <label class="data-name">Seleccionado(s):</label>
        <div class="d-flex flex-wrap">
          <div
            v-for="(item, index) in model"
            :key="item.id"
            class="w-content border rounded-pill d-flex align-items-center p-2 m-2"
          >
            <div class="font-weight-bold ml-1">Aplicación:</div>
            <div class="mx-1">{{ item.app.name }}</div>
            <div class="font-weight-bold ml-2">Rol:</div>
            <div class="mx-1">{{ item.role.name }}</div>
            <div v-if="!readOnly" class="mx-1" @click="remove(item, index)">
              <i class="pointer far fa-times-circle text-danger"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import { getApplications } from '@/modules/common/code.api.js';
import { getRolesByApp } from '@/modules/user/api';

export default {
  name: 'Roles',
  components: {
    SectionTitle,
    CustomDropDown,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    app: null,
    role: null,
    apps: [],
    roles: [],
  }),
  async mounted() {
    await this.getApps();
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isAppDisabled() {
      return this.readOnly || Boolean(this.model.length);
    },
    isRoleDisabled() {
      return this.readOnly || !this.appSelected;
    },
    appSelected: {
      get() {
        const app = this.model.map((y) => y.app)[0];
        if (!this.roles.length) this.getRoles(app);
        return app ?? this.app;
      },
      set(value) {
        this.app = value;
      },
    },
    appOptions() {
      return this.apps
        .filter((x) => !this.model.map((y) => y.app.id).includes(x.id))
        .sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
        );
    },
    roleOptions() {
      return this.roles
        .filter((x) => !this.model.map((y) => y.role.id).includes(x.id))
        .sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
        );
    },
  },
  methods: {
    async getApps() {
      const { data } = await getApplications();
      this.apps = data.map((x) => ({
        id: x.keyId,
        name: x.name,
      }));
    },
    async getRoles(app) {
      this.role = null;
      this.roles = [];
      if (!app) return;
      const { data } = await getRolesByApp(app.id);
      this.roles = data;
    },
    async add() {
      const validator = this.$refs.form;
      const isValid = await validator.validate();
      if (!isValid) return;
      const item = {
        app: this.appSelected,
        role: this.role,
      };
      this.model.push(item);
      this.role = null;
      validator.reset();
    },
    remove(item) {
      const index = this.model.indexOf(item);
      this.model.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.w-content {
  width: fit-content;
}
.pointer {
  cursor: pointer;
}
</style>
